<script>
import ParameterInput from './ParameterInput.vue';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import InputNext from 'next/input/Input.vue';
import ButtonNext from 'next/button/Button.vue';

export default {
  components: {
    ParameterInput,
    InputNext,
    ButtonNext,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    showLabel: {
      type: Boolean,
      default: true,
    },
    hasDuplicate: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['remove', 'change'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      updatedKey: this.value.key,
      updatedValue: this.value.value,
    };
  },
  watch: {
    updatedKey() {
      this.onChange();
    },
    updatedValue() {
      this.onChange();
    },
  },
  validations() {
    return {
      updatedKey: {
        required,
      },
      updatedValue: {
        required,
      },
    };
  },
  methods: {
    onChange() {
      this.$emit('change', {
        key: this.updatedKey,
        value: this.updatedValue,
      });
    },
  },
};
</script>

<template>
  <div class="w-full flex gap-2">
    <div class="flex-1">
      <label>
        <ParameterInput
          v-model="updatedKey"
          :label="
            showLabel ? $t('WGPT_BOTS.EDIT.PARAMETER_ROW.FORM.KEY.LABEL') : ''
          "
          :disabled="disabled"
          :message-type="
            v$.updatedKey.$error || hasDuplicate ? 'error' : 'info'
          "
          :message="
            v$.updatedKey.$error
              ? $t('WGPT_BOTS.EDIT.PARAMETER_ROW.FORM.KEY.ERROR')
              : hasDuplicate
                ? $t('WGPT_BOTS.EDIT.PARAMETER_ROW.FORM.KEY.DUPLICATE_ERROR')
                : ''
          "
          class="!mt-0 !mb-1"
          @blur="v$.updatedKey.$touch"
        />
      </label>
    </div>

    <div class="flex-1">
      <label>
        <InputNext
          v-model="updatedValue"
          class="!mt-0 !mb-1"
          rows="2"
          type="text"
          :label="
            showLabel ? $t('WGPT_BOTS.EDIT.PARAMETER_ROW.FORM.VALUE.LABEL') : ''
          "
          :message-type="v$.updatedValue.$error ? 'error' : 'info'"
          :message="
            v$.updatedValue.$error
              ? $t('WGPT_BOTS.EDIT.PARAMETER_ROW.FORM.VALUE.ERROR')
              : ''
          "
          @blur="v$.updatedValue.$touch"
        />
      </label>
    </div>
    <div class="mt-1.5 mb-auto" :class="{ 'mt-8': showLabel }">
      <ButtonNext
        icon="i-lucide-x"
        color="slate"
        variant="ghost"
        size="xs"
        @click="$emit('remove')"
      />
    </div>
  </div>
</template>
